var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{attrs:{"unique-id":_vm.uniqueId,"is-modal-form":_vm.isModalForm,"form-title":_vm.formTitle,"form-sub-title":_vm.formSubTitle,"submit-title":_vm.submitTitle,"fields":_vm.fields,"on-submit":_vm.onSubmit,"form-price":_vm.formPrice}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d673cf0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/RequestForm.vue
// module id = 200
// module chunks = 0